import { render, staticRenderFns } from "./NameTest.vue?vue&type=template&id=d04400ac&scoped=true&"
import script from "./NameTest.vue?vue&type=script&lang=js&"
export * from "./NameTest.vue?vue&type=script&lang=js&"
import style0 from "./NameTest.vue?vue&type=style&index=0&id=d04400ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04400ac",
  null
  
)

export default component.exports